import { ButtonProps } from '@material-ui/core/Button';
import { Field, FieldProps } from 'formik';
import React from 'react';

import LoadingButton from './LoadingButton';

export default function SubmitButton(props: ButtonProps) {
  return (
    <Field>
      {({ form }: FieldProps) => (
        <LoadingButton
          type="submit"
          disabled={!form.isValid || props.disabled}
          loading={false}
          {...props}
        />
      )}
    </Field>
  );
}
